<div class="modal-header">
  <h5 class="modal-title">Edit Catalog Item</h5>
  <button type="button" class="close" aria-label="Close" (click)="onCancelClick()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form>
    <div class="row">
      <!-- LEFT COLUMN -->
      <div class="col-md-6">

        <div class="form-group">
          <label for="isbn">
            ISBN
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the ISBN of the book.<br><b>Example:</b> 978-3-16-148410-0"></i>
          </label>
          <input type="text" class="form-control" id="isbn"
                 [(ngModel)]="catalogItem.isbn" name="isbn"
                 placeholder="e.g., 978-3-16-148410-0">
        </div>

        <div class="form-group">
          <label for="title">
            Title
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the title of the book.<br><b>Example:</b> The Great Gatsby"></i>
          </label>
          <input type="text" class="form-control" id="title"
                 [(ngModel)]="catalogItem.title" name="title"
                 placeholder="e.g., The Great Gatsby">
        </div>

        <div class="form-group">
          <label for="edition">
            Edition
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the edition of the book.<br><b>Example:</b> 1st Edition"></i>
          </label>
          <input type="text" class="form-control" id="edition"
                 [(ngModel)]="catalogItem.edition" name="edition"
                 placeholder="e.g., 1st Edition">
        </div>

        <div class="form-group">
          <label for="editionYear">
            Edition Year
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the year of the edition.<br><b>Example:</b> 2020"></i>
          </label>
          <input type="text" class="form-control" id="editionYear"
                 [(ngModel)]="catalogItem.edition_year" name="editionYear"
                 placeholder="e.g., 2020">
        </div>

        <div class="form-group">
          <label for="publishingYear">
            Publishing Year
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the year the book was published.<br><b>Example:</b> 2021"></i>
          </label>
          <input type="text" class="form-control" id="publishingYear"
                 [(ngModel)]="catalogItem.publishing_year" name="publishingYear"
                 placeholder="e.g., 2021">
        </div>

      </div>

      <!-- RIGHT COLUMN -->
      <div class="col-md-6">

        <div class="form-group">
          <label for="publicationPlace">
            Publication Place
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter where the book was published.<br><b>Example:</b> New York"></i>
          </label>
          <input type="text" class="form-control" id="publicationPlace"
                 [(ngModel)]="catalogItem.publication_place" name="publicationPlace"
                 placeholder="e.g., New York">
        </div>

        <div class="form-group">
          <label for="numberOfPages">
            Number of Pages
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter the total number of pages.<br><b>Example:</b> 200"></i>
          </label>
          <input type="number" class="form-control" id="numberOfPages"
                 [(ngModel)]="catalogItem.number_of_pages" name="numberOfPages"
                 placeholder="e.g., 200">
        </div>

        <div class="form-group">
          <label for="quantity">
            Quantity
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Enter how many copies of this item the library has.<br><b>Example:</b> 5"></i>
          </label>
          <input type="number" class="form-control" id="quantity"
                 [(ngModel)]="catalogItem.quantity" name="quantity" min="1"
                 placeholder="e.g., 5">
        </div>

        <div class="form-group">
          <label for="notes">
            Notes
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Any additional notes about the book."></i>
          </label>
          <textarea class="form-control" id="notes"
                    [(ngModel)]="catalogItem.notes" name="notes"
                    rows="3" placeholder="e.g., Important for studies"></textarea>
        </div>

        <div class="form-group">
          <label for="mediaType">
            Media Type
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the media type of the book."></i>
          </label>
          <select name="mediaType" [(ngModel)]="catalogItem.mediaType" class="form-control">
            <option *ngFor="let mediaType of mediaTypes" [ngValue]="mediaType">
              {{ mediaType.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="physicalDescription">
            Physical Description
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the physical description (e.g., hardcover, paperback)."></i>
          </label>
          <select name="physicalDescription"
                  [(ngModel)]="catalogItem.physical_description"
                  class="form-control">
            <option *ngFor="let description of physicalDescriptions" [ngValue]="description">
              {{ description.bindingType }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="writer">
            Writer
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the writer of the book."></i>
          </label>
          <select name="writer" [(ngModel)]="catalogItem.writer" class="form-control">
            <option *ngFor="let writer of writers" [ngValue]="writer">
              {{ writer.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="publisher">
            Publisher
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the publisher of the book."></i>
          </label>
          <select name="publisher" [(ngModel)]="catalogItem.publisher" class="form-control">
            <option *ngFor="let publisher of publishers" [ngValue]="publisher">
              {{ publisher.name }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="department">
            Department
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the department for the book."></i>
          </label>
          <select name="department" [(ngModel)]="catalogItem.departement" class="form-control">
            <option *ngFor="let department of departments" [ngValue]="department">
              {{ department.departmentName }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="shelf">
            Shelf
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the shelf location for the book."></i>
          </label>
          <select name="shelf" [(ngModel)]="catalogItem.shelf" class="form-control">
            <option *ngFor="let shelf of shelves" [ngValue]="shelf">
              {{ shelf.location }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="row">
            Row
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the row location for the book."></i>
          </label>
          <select name="row" [(ngModel)]="catalogItem.row" class="form-control">
            <option *ngFor="let row of rows" [ngValue]="row">
              {{ row.rowName }}
            </option>
          </select>
        </div>

        <div class="form-group">
          <label for="category">
            Category
            <i class="fas fa-info-circle" data-toggle="tooltip" data-html="true"
               title="<b>Description:</b> Select the category of the book."></i>
          </label>
          <select name="category" [(ngModel)]="catalogItem.category" class="form-control">
            <option *ngFor="let category of categories" [ngValue]="category">
              {{ category.category_name }}
            </option>
          </select>
        </div>

      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="onCancelClick()">Cancel</button>
      <button type="button" class="btn btn-outline-primary" (click)="saveCatalogItem()">Update</button>
    </div>
  </form>
</div>